class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;

      // The add to cart response on this store comes back without rendered
      // sections, because the Unicorn cart drawer handles the cart and owns the
      // post-add experience. Stop here rather than throwing on the missing
      // data. Deliberately without calling open(): this notification is not
      // what customers see today, and showing it would double up with the
      // drawer.
      if (!parsedState || !parsedState.sections) return;

      this.getSectionsToRender().forEach((section => {
        const target = document.getElementById(section.id);
        const html = parsedState.sections[section.id];
        if (!target || !html) return;

        const rendered = this.getSectionInnerHTML(html, section.selector);
        if (rendered !== null) target.innerHTML = rendered;
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    // The line item selector is built from the cart item key, so it misses
    // whenever an app rewrites the line (bundles, preorder). Returning null
    // lets the caller skip that one section instead of the whole update.
    return node ? node.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
